import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=3d4834c9&scoped=true&"
import script from "./ProcessMIRIP.vue?vue&type=script&lang=js&"
export * from "./ProcessMIRIP.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=3d4834c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4834c9",
  null
  
)

export default component.exports